import type { LucideIcon } from 'lucide-react';
import {
  QrCode,
  Calculator,
  Image,
  PenTool,
  UsersRound,
  Code2,
  FileCode,
  Link,
  MessageCircle,
  FileText,
  Plane,
  Receipt,
  Building2,
  UtensilsCrossed,
  Bot,
  Mic,
  Sparkles,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  QrCode,
  Calculator,
  Image,
  PenTool,
  UsersRound,
  Code2,
  FileCode,
  Link,
  MessageCircle,
  FileText,
  Plane,
  Receipt,
  Building2,
  UtensilsCrossed,
  Bot,
  Mic,
  Sparkles,
};

/**
 * 依工具資料的 icon 字串取得 lucide 圖示元件
 */
export function getIconComponent(name: string): LucideIcon | null {
  return ICON_MAP[name] ?? null;
}
